(() => {
  const roots = document.querySelectorAll('[data-ll-about-intro]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const items = [...root.querySelectorAll('[data-ll-about-acc-item]')];
    if (!items.length) return;

    const setOpen = (index) => {
      items.forEach((item, i) => {
        const on = i === index;
        const btn = item.querySelector('[data-ll-about-acc-trigger]');
        item.classList.toggle('is-open', on);
        if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    };

    items.forEach((item, i) => {
      const btn = item.querySelector('[data-ll-about-acc-trigger]');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        setOpen(isOpen ? -1 : i);
      });
    });

    // All closed by default
    setOpen(-1);
  });
})();
